module.exports = __webpack_public_path__ + "static/media/task-it.ad25c450.jpeg";